"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMaskAdapter = exports.mipdstore = void 0;
const onboarding_1 = __importDefault(require("@metamask/onboarding"));
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const mipd_1 = require("mipd");
const shapeshift_multichain_1 = require("./shapeshift-multichain");
exports.mipdstore = (0, mipd_1.createStore)();
const METAMASK_RDNS = "io.metamask";
class MetaMaskAdapter {
    constructor(keyring, providerRdns) {
        this.keyring = keyring;
        this.providerRdns = providerRdns;
    }
    static useKeyring(keyring, providerRdns) {
        return new MetaMaskAdapter(keyring, providerRdns);
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.keys(this.keyring.wallets).length;
        });
    }
    pairDevice() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const maybeEip6963Provider = exports.mipdstore.findProvider({ rdns: this.providerRdns });
            if (!maybeEip6963Provider && this.providerRdns === METAMASK_RDNS) {
                const onboarding = new onboarding_1.default();
                onboarding.startOnboarding();
                console.error("Please install MetaMask!");
                throw new Error("MetaMask provider not found");
            }
            // If we were only dealing with *detected* rdns, this would never happen, however
            // web contains a static list of rdns we want to display at all times to indicate support to users
            // Meaning we may hit this without the wallet actually being installed
            if (!maybeEip6963Provider)
                throw new Error("EIP-6963 provider not found");
            const eip1193Provider = maybeEip6963Provider.provider;
            try {
                yield ((_a = eip1193Provider.request) === null || _a === void 0 ? void 0 : _a.call(eip1193Provider, { method: "eth_requestAccounts" }).catch(() => {
                    var _a;
                    return (_a = eip1193Provider.request) === null || _a === void 0 ? void 0 : _a.call(eip1193Provider, {
                        method: "wallet_requestPermissions",
                        params: [{ eth_accounts: {} }],
                    });
                }));
            }
            catch (error) {
                console.error("Could not get MetaMask accounts. ");
                throw error;
            }
            const wallet = new shapeshift_multichain_1.MetaMaskMultiChainHDWallet(maybeEip6963Provider);
            yield wallet.initialize();
            const deviceID = yield wallet.getDeviceID();
            this.keyring.add(wallet, deviceID);
            this.keyring.emit(["MetaMask(ShapeShift Multichain)", deviceID, core.Events.CONNECT], deviceID);
            return wallet;
        });
    }
}
exports.MetaMaskAdapter = MetaMaskAdapter;
//# sourceMappingURL=adapter.js.map